"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M22 11.5v2h-4.35c2.22 4.41-.64 9.5-5.65 9.5-3.55 0-6.55-2.46-6.53-6.5h3.02c-.03.18-.05.37-.05.56 0 1.97 1.59 3.56 3.56 3.56s3.56-1.59 3.56-3.56S13.97 13.5 12 13.5H2v-2h20zM8.44 7.94c0-1.97 1.59-3.56 3.56-3.56s3.56 1.59 3.56 3.56c0 .19-.02.38-.05.56h3.02C18.55 4.46 15.55 2 12 2 8.12 2 5.54 5.07 5.6 8.5h2.89a3.43 3.43 0 01-.05-.56z" }), "StrikeThrough");
//# sourceMappingURL=StrikeThrough.js.map